module.exports = __webpack_public_path__ + "img/gigawhat-mockup_mac_2.20a43ffa.svg";